import { type PreferenceOptionKey } from '@hungryroot/rest/api/v2/preference_options/get/get_preference_options';
import { useGetPreferenceOptions } from './use-get-preference-options';

export function usePagePreferenceOptions(page: PreferenceOptionKey) {
  const { data: preferenceOptionPages } = useGetPreferenceOptions();
  return preferenceOptionPages?.pages.find((pageData) => pageData.key === page)
    ?.options;
}
